import React, {Component} from 'react';
import Round1 from './Round1';
import Round2 from './Round2';
import Round3 from './Round3';
import Round4 from './Round4';
import Round5 from './Round5';
import Round6 from './Round6';
import Round7 from './Round7';
import Circles from './Circles';
import './bracket.css';
// import teamData from './data/data';
import DataContainer from './data/data';
import { Subscribe } from 'unstated';

class Bracket extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Subscribe to={[DataContainer]}>
                {(DataContainer) => (
                    <div className="bracket wrapper">
                        {DataContainer.state.rounds ? (
                            <>
                                <Round1 teams={DataContainer.state.rounds[0]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round2 teams={DataContainer.state.rounds[1]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round3 teams={DataContainer.state.rounds[2]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round4 teams={DataContainer.state.rounds[3]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round5 teams={DataContainer.state.rounds[4]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round6 teams={DataContainer.state.rounds[5]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Round7 teams={DataContainer.state.rounds[6]} onClick={DataContainer.onClick} onHover={DataContainer.onHover}/>
                                <Circles />
                            </>
                        ):''}
                    </div>
                )}
            </Subscribe>
        );
    }
}

export default Bracket;